import { render, staticRenderFns } from "./AddDriverStatements.vue?vue&type=template&id=d16017c0&scoped=true"
import script from "./AddDriverStatements.vue?vue&type=script&lang=js"
export * from "./AddDriverStatements.vue?vue&type=script&lang=js"
import style0 from "./AddDriverStatements.vue?vue&type=style&index=0&id=d16017c0&prod&scoped=true&lang=scss"
import style1 from "./AddDriverStatements.vue?vue&type=style&index=1&id=d16017c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16017c0",
  null
  
)

export default component.exports